export enum ErrorCode {
  UNAUTHORIZED = 401,
  ACCESS_DENIED = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
}
